import { createSlice} from "@reduxjs/toolkit";

interface IOrderState {
    isOpenOrderDetail:boolean;
    isOpenPurchaserAccessory:boolean;
    isOpenPurchaserYarn:boolean;
    
}
const initialState: IOrderState = {
    isOpenOrderDetail:false,
    isOpenPurchaserYarn:false,
    isOpenPurchaserAccessory:false
};
const timelineSlice = createSlice({
  name: "timeline",
  initialState,
  reducers: {
  setIsOpenOrderDetail: (state, action) => {
      state.isOpenOrderDetail =action.payload;
  },
  setIsOpenPurchaserYarn:(state,action)=>{
    state.isOpenPurchaserYarn=action.payload;
  },
  setIsOpenPurchaserAccessory:(state,action)=>{
    state.isOpenPurchaserAccessory=action.payload;
  }
  },
});

export const {setIsOpenOrderDetail,setIsOpenPurchaserYarn,setIsOpenPurchaserAccessory} =
  timelineSlice.actions;

export default timelineSlice.reducer;